import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import type { Observable } from "rxjs";
import type { Message } from "src/app/schema";
import { ApiService, CognitoService, WorkspaceService } from "src/app/services";

@Injectable({
	providedIn: "root",
})
export class AutopilotService {
	private readonly _api = inject(ApiService);
	private readonly _httpClient = inject(HttpClient);
	private readonly _cognitoService = inject(CognitoService);
	private readonly _workspaceService = inject(WorkspaceService);

	public accept(leadId: string, message: string): Observable<Message> {
		return this._httpClient.post<Message>(
			`${this._api.communicationsApiEndpoint}/autopilot/${leadId}/accept`,
			{
				userId: this._cognitoService.user().id,
				message,
				propertyId: this._workspaceService.workspaceId(),
			},
		);
	}

	public modify(leadId: string, message: string): Observable<Message> {
		return this._httpClient.post<Message>(
			`${this._api.communicationsApiEndpoint}/autopilot/${leadId}/modify`,
			{
				userId: this._cognitoService.user().id,
				message,
				propertyId: this._workspaceService.workspaceId(),
			},
		);
	}

	public dismiss(leadId: string): Observable<void> {
		return this._httpClient.post<void>(
			`${this._api.communicationsApiEndpoint}/autopilot/${leadId}/dismiss`,
			{
				userId: this._cognitoService.user().id,
				propertyId: this._workspaceService.workspaceId(),
			},
		);
	}
}
